import { useI18n } from '@i18n';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import InputBase from '@mui/material/InputBase';
import { ChangeEvent, useEffect, useRef } from 'react';
import { ICONS } from '@/assets/icons';
import { SearchIcon } from '@/assets/Icons/SearchIcon';
import Iconify from '@/components/Iconify';
import { ICON_SIZE_MAP } from '@/config';
import { useGlobalSearchContext } from '@/contexts/GlobalSearchContext';

function GlobalSearchHeader() {
  const { t } = useI18n();
  const inputRef = useRef<HTMLInputElement>(null);

  const { state, send } = useGlobalSearchContext();
  const isOpen = state.matches('open');
  const query = state.context.query;

  useEffect(() => {
    if (isOpen && inputRef.current) {
      setTimeout(() => {
        inputRef.current?.focus();
      }, 100);
    }
  }, [isOpen]);

  const handleClear = () => {
    send({ type: 'RESET' });
    inputRef.current?.focus();
  };

  return (
    <Box sx={{ p: 3, borderBottom: (theme) => `solid 1px ${theme.palette.divider}` }}>
      <InputBase
        fullWidth
        placeholder={t('GlobalSearch_SearchPredium')}
        value={query}
        onChange={(event: ChangeEvent<HTMLTextAreaElement>) =>
          send({ type: 'CHANGE_INPUT', query: event.target.value })
        }
        inputRef={inputRef}
        startAdornment={
          <InputAdornment position="start">
            <SearchIcon size="md" sx={{ color: 'text.disabled' }} />
          </InputAdornment>
        }
        endAdornment={
          query ? (
            <InputAdornment position="end">
              <IconButton onClick={handleClear} size="small" aria-label={t('General_Clear')}>
                <Iconify
                  icon={ICONS.CLOSE_CIRCLE}
                  width={ICON_SIZE_MAP.sm}
                  height={ICON_SIZE_MAP.sm}
                  sx={{ color: 'text.disabled' }}
                />
              </IconButton>
            </InputAdornment>
          ) : null
        }
        inputProps={{
          sx: { typography: 'h6' },
        }}
      />
    </Box>
  );
}

export default GlobalSearchHeader;
